// extracted by mini-css-extract-plugin
export default {"header":"ClientsList_header__4lUlR"};